import { EventEmitter } from "pixi.js";


export enum EnumEventBus {
  setSelectedTool = "SET_SELECTED_TOOL",
  delLastDrawing = "DELETE_LAST_DRAWING",
  clearAll = "CLEAR_All_OF_GRAPHICS",

  newQuestion = "NEW_QUESTION",
  setTracingMode = "SET_TRACING_MODE",
  animateTracingPaper = "ANIMATE_TRACING_PAPER",
  animateHint = "ANIMATE_HINT",
  setShowSolution = "SET_SHOW_SOLUTION",
  showTestQuestion = "SHOW_TEST_QUESTION",

  setActiveQuestionType = "SET_ACTIVE_QUESTION_TYPE",
  questionType = "QUESTION_TYPE",
  setQuestMode = "SET_QUESTION_MODE",
  startTest = "START_TEST",
  openHTPModal = "OPEN_HOW_TO_PLAY_MODAL",

  startAnswer = "START_ANSWER",
  saveAnswer = "SAVE_ANSWER",
  checkAnswer = "CHECK_ANSWER",
  checkedAnswers = "CHECKED_ANSWERS",
  setDirection = "SET_DIRECTION",
  setRotation = "SET_ROTATION",
  showRuler = "SHOW_RULER",
  showProtractor = "SHOW_PROTRACTOR",
  showResults = "SHOW_RESULTS",
  showCompass = "SHOW_COMPASS"
}


export const eventBus = new EventEmitter();